<template>
    <div>
        <div class="px-2">
            <label class="selected-products-label">
                {{ $t('v4.Select a Product') }}
            </label>
            <div class="selected-products d-flex">
                <span class="filter-icon">
                    <SVGFilterIcon/>
                </span>
                <div
                    class="selected-products-input"
                    @click="showModal"
                    :disabled="productList.length === 0"
                >
                    <div>
                        <span
                            v-if="filterBoxObj.list.length === 0"
                            class="selected-products-placeholder"
                        >
                            {{ $t('org.dashboard.Select a Project') }}
                        </span>
                        <span
                            class="selected-product"
                            v-for="(item, index) in filterBoxObj.list"
                            :key="index"
                        >
                            {{ item }}
                        </span>
                        <span
                            v-if="filterBoxObj.etcNum"
                            class="selected-product-etc"
                        >
                            +{{ filterBoxObj.etcNum }}
                        </span>
                    </div>
                    <div>
                        <span
                            v-if="selectedFilter.length"
                            class="mr-1"
                            @click="handleRemoveSelectedFilter"
                        >
                            <SVGXIcon/>
                        </span>
                        <span>
                            <SVGArrowDownIcon/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            ref="CARD_DATES_DETAIL_PRODUCT_LIST"
            centered
            size="md"
            @ok="handleSaveSelectedFilter"
            modalClass="modal-with-checkbox"
            :ok-title="modalText.okTitle"
            :cancel-title="modalText.cancelTitle"
            cancel-variant="flat-secondary"
        >
            <template v-slot:modal-header-close>
                <SVGModalXIcon/>
            </template>
            <div class="modal-title">
                <h2>{{ $t('org.dashboard.Select Filter') }}</h2>
                <p>{{ $t('org.dashboard.Select the items to apply to the graph') }}</p>
            </div>
            <div class="modal-body-checkbox">
                <div class="checkbox-search">
                    <label>
                        {{ $t('v4.Product Name' )}}
                    </label>
                    <b-input-group class="search-input-group">
                        <b-input-group-prepend is-text>
                            <SVGWidgetSearchIcon/>
                        </b-input-group-prepend>
                        <b-form-input
                            class="search-input-space"
                            :placeholder="$t('v4.Search')"
                            v-model="searchValue"
                        />
                    </b-input-group>
                </div>
                <div class="checkbox-list">
                    <div class="checkbox-list-title d-flex justify-content-between">
                        <label class="title">
                            {{ $t('v4.All Products') }}
                        </label>
                        <b-checkbox
                            v-model="allSelected"
                            aria-describedby="products"
                            aria-controls="products"
                            @change="toggleAll"
                            stacked
                        >
                            {{ $t('org.dashboard.Select all') }}
                        </b-checkbox>
                    </div>
                    <b-form-group class="checkbox-group">
                        <b-form-checkbox-group
                            v-model="selectedModalItems"
                            name="products"
                            :options="filterItems"
                        >
                        </b-form-checkbox-group>
                    </b-form-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { ref, toRefs, watch, computed, getCurrentInstance } from '@vue/composition-api'
import SVGFilterIcon from '@/assets/images/icons/icon_filter.svg'
import SVGXIcon from '@/assets/images/icons/icon_x.svg'
import SVGArrowDownIcon from '@/assets/images/icons/icon_arrow_down.svg'
import SVGWidgetSearchIcon from '@/assets/images/icons/widget-search.svg'
import SVGModalXIcon from '@/assets/images/icons/icon_modal_X.svg'
export default {
    components: {
        SVGFilterIcon,
        SVGXIcon,
        SVGArrowDownIcon,
        SVGWidgetSearchIcon,
        SVGModalXIcon
    },
    props: {
        productList: {
            type: Array,
            default: () => []
        }
    },
    setup (props, context) {
        const { productList } = toRefs(props)
        const allSelected = ref(true)
        const selectedFilter = ref(productList.value.slice())
        const filterBoxObj = computed(() => {
            let totalTextLength = 0
            let hideIdx = 0
            selectedFilter.value.forEach((item, idx) => {
                if (idx > 0) totalTextLength += 30
                totalTextLength += item.length * 9
                if (hideIdx === 0 && totalTextLength >= 660) hideIdx = idx
            })
            const etcNum = selectedFilter.value.length - hideIdx
            return {
                list: hideIdx === 0 ? selectedFilter.value : selectedFilter.value.slice(0, hideIdx),
                etcNum: hideIdx === 0 ? 0 : etcNum
            }
        })
        /** modal */
        const vm = getCurrentInstance().proxy
        const searchValue = ref('')
        const selectedModalItems = ref(productList.value)
        const modalText = computed(() => ({
            'okTitle': vm.$t('org.dashboard.Apply'),
            'cancelTitle': vm.$t('org.dashboard.Cancel')
        }))
        const CARD_DATES_DETAIL_PRODUCT_LIST = ref(null)
        const showModal = () => {
            if (productList.value.length === 0) return
            if (CARD_DATES_DETAIL_PRODUCT_LIST.value) {
                searchValue.value = ''
                selectedModalItems.value = selectedFilter.value
                CARD_DATES_DETAIL_PRODUCT_LIST.value.show()
            }
        }
        const handleSaveSelectedFilter = () => {
            selectedFilter.value = selectedModalItems.value
            context.emit('save:filter', selectedModalItems.value)
        }
        const handleRemoveSelectedFilter = (event) => {
            event.stopPropagation()
            selectedFilter.value = []
            context.emit('save:filter', [])
        }
        const filterItems = computed(() => searchValue.value ? productList.value.filter(item => item.toLowerCase().indexOf(searchValue.value.toLowerCase()) > -1) : productList.value)

        const toggleAll = (checked) => {
            selectedModalItems.value = checked ? productList.value.slice() : []
        }
        watch(productList, (value, oldValue) => {
            selectedFilter.value = value
        })
        watch(selectedModalItems, (value, oldValue) => {
            if (value.length === productList.value.length) {
                allSelected.value = true
            } else {
                allSelected.value = false
            }
        })
        return {
            searchValue,
            allSelected,
            selectedFilter,
            toggleAll,
            modalText,
            showModal,
            handleSaveSelectedFilter,
            handleRemoveSelectedFilter,
            filterItems,
            filterBoxObj,
            CARD_DATES_DETAIL_PRODUCT_LIST,
            selectedModalItems
        }
    }
}
</script>
<style lang="scss">
.selected-products-label {
    font-size: 0.95rem;
}
.selected-products {
    display: flex;
    align-items: center;
}
.selected-products-placeholder {
    color: #C8C8C8;
}
.selected-products-input {
    width: 100%;
    max-width: 752px;
    margin-left: 0.75rem;
    padding: 0.5rem 0.85rem;
    border: 1px solid #DFDFE1;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}
.selected-products-input[disabled] {
    cursor: not-allowed;
}
.dark-layout {
    .selected-products-input[disabled] {
        background-color: #283046;
        border: 1px solid #404656 !important;
    }
}
.selected-products-input .selected-product {
    color: #5F5C6A;
    background: #F0F0F1;
    padding: 0.35rem 0.6rem;
    margin-right: 2px;
    border-radius: 4px;
}
.selected-products-input .selected-product-etc {
    margin-left: 6px;
    color: #5F5C6A;
}

/* modal-with-checkbox */
.modal-with-checkbox .modal-dialog {
    max-width: 700px;
    width: 100%;
}
.modal-with-checkbox .checkbox-group > div {
    display: flex;
    flex-wrap: wrap;
}
.modal-with-checkbox .checkbox-group > div .custom-checkbox {
    width: 50% !important;
    margin: 0.70rem 0;
}
.modal-with-checkbox .search-input-group .custom-checkbox .custom-control-label::before,
.modal-with-checkbox .search-input-group .custom-checkbox .custom-control-label::after,
.modal-with-checkbox .search-input-group .custom-radio .custom-control-label::before,
.modal-with-checkbox .search-input-group .custom-radio .custom-control-label::after {
    width: 20px !important;
    height: 20px !important;
    margin: 1rem 0;
}
.modal-with-checkbox .search-input-group .form-control {
    border-left: none;
    height: 36px;
}
.modal-with-checkbox .search-input-group .custom-control {
    padding-left: 3rem;
}
.modal-with-checkbox .search-input-group {
    height: 36px !important;
}
.modal-with-checkbox .search-input-group .input-group-text {
    padding: 4px 0 4px 8px;
}
.modal-with-checkbox .search-input-group .search-input-space {
    padding: 9px 0 9px 8px;
    font-size: 15px;
    line-height: 0;
}
.modal-with-checkbox .search-input-space::placeholder {
    color: #C8C8C8;
}
.modal-with-checkbox .modal-header {
    background-color: transparent;
}
.modal-with-checkbox .modal-title {
    text-align: center;
}
.modal-with-checkbox .modal-header .close {
    transform: translate(12px, -9px);
    width: 30px;
    height: 30px;
    padding: 0;
}
.modal-with-checkbox .modal-header .close svg {
    margin-bottom: 5px;
}
.modal-with-checkbox .modal-body {
    padding: 30px 0 0 0 !important;
}
.modal-with-checkbox .modal-title > p {
    font-size: 1.05rem;
    margin: 0;
}
.modal-with-checkbox .modal-body-checkbox {
    padding: 0;
    margin-top: 24px;
}
.modal-with-checkbox .modal-body-checkbox .checkbox-search {
    padding: 0 64px;
}
.modal-with-checkbox .modal-body-checkbox .checkbox-search > label {
    font-size: 0.95rem;
    margin-bottom: 2px;
}
.modal-with-checkbox .modal-body-checkbox .checkbox-list .checkbox-list-title {
    margin-top: 32px;
    margin-bottom: 6px;
    padding: 0 64px;
}
.modal-with-checkbox .modal-body-checkbox .checkbox-list .checkbox-list-title .title {
    font-size: 1.3rem;
}
.modal-with-checkbox .modal-body-checkbox .checkbox-list .checkbox-group {
    overflow-y: scroll;
    height: 256px;
    padding: 0 64px;
}
.modal-with-checkbox .modal-footer {
    padding: 24px 40px 40px 40px;
}
.modal-with-checkbox .modal-footer .btn {
    margin: 0 0 0 10px;
    font-weight: 300;
    font-size: 1.05rem;
}
.modal-with-checkbox .modal-footer .btn-flat-secondary {
    background-color: rgba(128, 131, 144, 0.2);
    color: #808390;
}
</style>
